import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import * as _ from 'lodash';

@Injectable()
export class FormsErrorsService {

    formErrors = []
    className = 'FormsErrorsService';

    private _subject: Subject<any>;
    observer: Observable<any>;

    private _subjectVisible: Subject<any>;
    observerVisible: Observable<any>;

    constructor() {
        this._subject = new Subject<any>();
        this.observer = this._subject.asObservable();

        this._subjectVisible = new Subject<any>();
        this.observerVisible = this._subjectVisible.asObservable();
    }

    notify(data) {
        this._subject.next(data);
    }

    registerFormError(formError) {
        if (!_.find(this.formErrors, fe => _.get(fe, 'uuid') === _.get(formError, 'uuid'))) {
            this.formErrors.push(formError);
            this.notify(this.formErrors);
        }
    }

    unregisterFormError(formError) {
        _.remove(this.formErrors, (fe) => {
            return _.get(fe, 'uuid') === _.get(formError, 'uuid');
        })
        this.notify(this.formErrors);
    }

    notifyVisible(flag) {
        this._subjectVisible.next(flag);
    }
}